export default __webpack_public_path__ + "static/media/img-time-l-9.cbb21f61.svg";